import { Injectable, Signal } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export abstract class PrivilegeService {
	abstract privileges: Signal<string[] | undefined>;
	abstract privileges$: Observable<string[] | undefined>;

	abstract roles: Signal<string[] | undefined>;
	abstract roles$: Observable<string[] | undefined>;

	abstract hasPrivilege(privilege: string | string[]): Signal<boolean>;
	abstract hasRole(role: string | string[]): Signal<boolean>;
	abstract hasAccess(privilege: string | string[], role: string | string[]): Signal<boolean>;
}
